import { ICommonLink } from '@src/models/common';

export const JOB: ICommonLink = {
  id: 'jobLink',
  disableNextJs: true,
  href: 'https://centraai.notion.site/Careers-at-Centra-7439454d712b4b97a0cad91e5fbb24ba',
  name: 'Карьера в Centra',
};

export const MAIL: ICommonLink = {
  id: 'mailToHelloLink',
  href: 'mailto:hello@centra.ai',
  icon: 'mail',
  name: 'hello@centra.ai',
  target: '_blank',
  disableNextJs: true,
};

export const PHONE: ICommonLink = {
  id: 'phoneLink',
  href: 'tel:+74952868188',
  icon: 'phone',
  name: '+7 (495) 286 81 88',
  target: '_blank',
  disableNextJs: true,
};

export const TELEGRAM: ICommonLink = {
  href: 'https://t.me/centranew',
  icon: 'telegram',
  id: 'telegramLink',
  name: 'Наш telegram',
  target: '_blank',
  disableNextJs: true,
};

export const YOU_TUBE: ICommonLink = {
  href: 'https://www.youtube.com/channel/UCOOjVhJrMr-38FTanG2nhQw/featured',
  icon: 'youTube',
  id: 'youTubeLink',
  name: 'YouTube',
  target: '_blank',
  disableNextJs: true,
};
